class SiteLoader {
    constructor(json_url = '', config = {}, debug = false) {
        if (!json_url) {
            console.error("[Loader] json_url");
            return false;
        }

        const _ = this,
            default_config = {
                progress: percentage => { },
                complete: () => { },
                elementLoaded: (obj, elm) => { }
            };

        if (config.progress)
            default_config.progress = config.progress;
        if (config.complete)
            default_config.complete = config.complete;
        if (config.elementLoaded)
            default_config.elementLoaded = config.elementLoaded;

        $.html5Loader({
            filesToLoad: json_url,
            onComplete: () => {
                default_config.complete();
            },
            onElementLoaded: (obj, elm) => {
                default_config.elementLoaded(obj, elm);
            },
            onMediaError: (obj, elm) => {
                console.error("[Loader] onMediaError");
                console.error(obj, elm);
            },
            onUpdate: percentage => {
                default_config.progress(percentage);
            },
            debugMode: debug,
        });
    }
}
